import React, { useState } from 'react';
import { ShoppingCart } from 'lucide-react';

// Main promotional component
const PromoSection = () => {
  const [email, setEmail] = useState('');

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      {/* Black Friday Banner Section */}
      <div className="max-w-7xl mx-auto mb-8">
        <div className="relative rounded-2xl shadow-lg overflow-hidden">
          <img 
            src="https://via.placeholder.com/1400x700/4A5568/fff?text=Black+Friday+Banner" 
            alt="Black Friday Banner" 
            className="w-full h-auto object-cover"
          />
        </div>
      </div>

      {/* Product Cards Section */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Log Collection Card */}
        <div className="bg-purple-100 rounded-2xl p-8 relative">
          <span className="bg-pink-200 text-xs px-3 py-1 rounded-full inline-block mb-4">REFILLS</span>
          <img src="https://via.placeholder.com/200x200/8B5CF6/fff?text=Notebooks" alt="Colorful notebooks" className="w-full mb-4 rounded-lg" />
          <h3 className="text-2xl font-bold mb-2">Log Collection</h3>
          <p className="text-gray-600 mb-4">Build it your way</p>
          <p className="text-sm mb-6">From €6.00</p>
          <button className="bg-black text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-gray-800 transition">
            Shop now
          </button>
        </div>

        {/* Accessories Card */}
        <div className="bg-orange-400 rounded-2xl p-8 relative">
          <img src="https://via.placeholder.com/200x200/F97316/fff?text=Accessories" alt="Colorful accessories" className="w-full mb-4 rounded-lg" />
          <h3 className="text-2xl font-bold mb-2 text-white">Accessories</h3>
          <p className="text-white mb-4">The final touch</p>
          <p className="text-sm mb-6 text-white">From €6.00</p>
          <button className="bg-black text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-gray-800 transition">
            Shop now
          </button>
        </div>

        {/* Newsletter Signup Card */}
        <div className="bg-orange-50 rounded-2xl p-8">
          <span className="bg-orange-200 text-xs px-3 py-1 rounded-full inline-block mb-4">20%</span>
          <img src="https://via.placeholder.com/200x150/D97706/fff?text=mishmash+box" alt="Box package" className="w-full mb-4 rounded-lg" />
          <h3 className="text-2xl font-bold mb-2">mishmash</h3>
          <p className="text-gray-600 mb-2">Get 20% off your first order.</p>
          <p className="text-sm text-gray-500 mb-4">Subscribe and unlock a discount when you make your first purchase. It is that simple.</p>
          <p className="font-medium mb-3">Claim your exclusive offer</p>
          <div className="flex gap-2">
            <input 
              type="email" 
              placeholder="Type your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-4 py-2 rounded-full border border-gray-300 focus:outline-none focus:border-gray-400"
            />
            <button className="bg-black text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-gray-800 transition">
              Join now
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default PromoSection;